import { alpha, IconButton, DialogContent as MuiDialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

export const DialogContent = styled(MuiDialogContent)({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: "10px",
  overflowY: "visible",

  ".MuiAutocomplete-root, & > .MuiFormControl-root": {
    width: "45%",
  },
});

export const AddButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "plusButton",
})<{
  plusButton: boolean;
}>({}, ({ theme, plusButton }) => ({
  ...(plusButton && {
    boxShadow: theme.shadows[3],
    transition: theme.transitions.create(["color", "backgroundColor"]),
    padding: 0,
    fontSize: "1.5em",
    lineHeight: "1.5em",
    color: theme.palette.primary.contrastText,
    borderColor: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      borderColor: alpha(theme.palette.primary.contrastText, 0.6),
    },
  }),
}));
